module.exports = __webpack_public_path__ + "static/media/a-staple-food-withstand-disaster.d89c1781.jpg";